export const ACTUALS = 'actuals'

export enum CustomKpiFormat {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
  NUMBER = 'number'
}
